<template>
  <div class="empty-state">
    <img
      v-if="image || defaultImage"
      class="empty-state-img"
      :src="image || defaultImage"
      alt=""
    />
    <div class="empty-state-text">{{ text }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    // 自定义图片
    image: { type: String, default: "" },
    // 提示文字
    text: { type: String, default: "No Data" }
  },
  data() {
    return {
      defaultImage: ""
    }
  }
}
</script>

<style lang="less" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 200px 0 60px;
  flex: 1;

  &-img {
    width: 360px;
    height: 360px;
    object-fit: contain;
    opacity: 0.85;
  }

  &-text {
    margin-top: 20px;
    font-size: 28px;
    color: #c6c6c6;
    font-weight: 400;
  }
}
</style>
